function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "46",
  height: "46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.428 19.912v12.124c0 1.48.363 2.873.994 4.107h8.213c1.163 0 2.293-1.171 2.293-2.224V18.106l-.461-.034h-9.198c-1.017 0-1.84.823-1.84 1.84zM26.012 13.143h-4.89c.7 2.198 2.735 3.8 5.164 3.8.577 0 1.12-.113 1.643-.28V15.06a1.923 1.923 0 00-1.917-1.917z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.863 18.071H32.66l-2.29 1.852v9.182a6.172 6.172 0 1012.344 0v-9.182c0-1.022-.83-1.852-1.851-1.852zM41.072 12.322a4.107 4.107 0 11-8.215 0 4.106 4.106 0 118.215 0z",
  fill: "#5059C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.268 18.071H32.66a1.84 1.84 0 011.84 1.84v12.125a9.035 9.035 0 01-9.036 9.035 9.035 9.035 0 01-9.035-9.035V19.91c0-1.017.823-1.84 1.84-1.84zM31.73 11.5a5.444 5.444 0 11-10.887-.002 5.444 5.444 0 0110.886.002z",
  fill: "#7B83EB"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".5",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.123 13.143h4.889c1.055 0 1.917.863 1.917 1.917v1.604a5.394 5.394 0 01-1.643.279c-2.43 0-4.463-1.602-5.163-3.8zm-4.695 18.893V19.912c0-1.017.823-1.84 1.84-1.84h9.199l.462.034V33.92c0 1.053-1.13 2.224-2.294 2.224h-8.213a8.992 8.992 0 01-.994-4.107z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.37 34.5H5.201a1.922 1.922 0 01-1.916-1.917V13.417c0-1.054.863-1.917 1.916-1.917h19.167c1.055 0 1.917.863 1.917 1.917v19.166A1.923 1.923 0 0124.37 34.5z",
  fill: "#4B53BC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.011 19.02h-3.925v10.55h-2.58V19.02H9.562v-2.592h10.45v2.592z",
  fill: "#fff"
}));